import { createContext } from 'react';

export interface DeviceContextType {
  size: { width: number; height: number };
  isSmall: boolean;
}

export function buildCurrentDevice(): DeviceContextType {
  return {
    size: { width: window.innerWidth, height: window.innerHeight },
    isSmall: window.innerWidth < 768, // TODO: check other media queries
  };
}

export const DeviceContext = createContext<DeviceContextType>({} as DeviceContextType);
